export const inJest = () => navigator.userAgent.includes(' jsdom')
